module.exports = __webpack_public_path__ + "img/jing.8c5435ea.png";